import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAssetEventSelectorId } from '../../utils/hsAnalytics';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';

const AssetSetupGuideButton = (_ref) => {
  let {
    offeringType,
    setupUrl
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["offeringType", "setupUrl"]);

  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  return /*#__PURE__*/_jsxs(UIButton, Object.assign({}, rest, {
    "data-hs-analytics-id": getAssetEventSelectorId('SETUP-GUIDE', offeringType),
    href: setupUrl,
    external: true,
    iconProps: {
      className: 'hidden'
    },
    onClick: () => trackInteraction('click setup guide link', {
      section: 'header'
    }),
    use: "link",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "lesson"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.details.setupGuide"
    })]
  }));
};

export default AssetSetupGuideButton;